import Notification from '../UI/Notification/Notification';
import { isBirthdayToday } from './birthdayUtils';

const BirthdayNotificationComponent = ({ dateOfBirth }) =>
  isBirthdayToday(dateOfBirth) ? <Notification status={'success'} message={'This client has birthday today'} /> : null;

export default BirthdayNotificationComponent;
